




































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import { fetchNDV } from './fetchNDV';
import {
  TableParam,
  CurrentId,
  DataApi as Api,
} from './models/NDVModalTabs.model';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import TabNDV from './TabsModals/TabNDV.vue';
import TabProducts from './TabsModals/Products/TabProducts.vue';
import TabReservations from './TabsModals/Reservations/TabReservations.vue';
import TabAttentions from './TabsModals/TabAttentions.vue';
import {
  DataApi,
  FunctionParams,
  ContextMsg,
  ParamsAttention,
} from './models/NDVBase.model';
import Confirmation from '@/components/Confirmation.vue';
import ModalInformativo from '@/components/ModalInformativo.vue';

@Component({
  components: {
    GridComponent: AgGridVue,
    TabNDV,
    TabProducts,
    TabReservations,
    TabAttentions,
    Confirmation,
    DatePicker,
    ModalInformativo,
  },
})
export default class NVDModalEnvioReservations extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true, default: {} }) data!: DataApi;
  @Prop({ required: true, default: 'atencion' }) tipo_emision: string;

  gridOptions: GridOptions = null;
  columnDefs: ColDef[] = [];
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnApi: any = null;
  loading: boolean = false;
  dialog: boolean = true;
  reservation_data: any = [];
  dialogPopUp: boolean = false;
  contextPopUp: ContextMsg = {};
  confirmations: number = 0;
  currentId: CurrentId = {
    products: null,
    reservations: null,
    attentions: null,
  };
  quickSearch: string = '';
  nro_factura: string = '';
  dataApi: Api = {
    products: [],
    reservations: [],
    attentions: [],
  };
  atencion: any = {
    tipoDocumento: 910,
    divisaNDV: '',
    divisaAtencion: 'CLP',
    tipoCambio: '',
    ordenCompra: '',
    fecha: '',
    observaciones: '',
  };
  fecha_maxima: any = new Date().toISOString().split('T')[0];
  modal_errores: boolean = false;
  lista_errores: any = null;
  mostrarHijo: boolean = false;
  localData: DataApi = {};
  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;

  constructor() {
    super();
    this.getFechaMax();
    //console.log('data ', this.data)
    this.localData = this.data;
    this.columnDefs = this.colsGrid();
    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowMultiSelectWithClick: true,
      rowSelection: 'multiple',
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
    this.atencion.ordenCompra = (this.localData as any)['Orden de Compra'];
    this.atencion.divisaNDV = (this.localData as any)['Divisa'];
  }
  async mounted() {
    this.reservation_data = await this.getData();
  }
  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData([]);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleClosed(): void {
    this.localData = {};
    Object.keys(this.currentId).forEach(
      key => (this.currentId[key as keyof CurrentId] = null)
    );
    this.$emit('cerrar');
  }

  showAlerta(): void {
    const selectedRowns = this.gridApi.getSelectedRows();
    if (selectedRowns.length < 1) {
      this.$snotify.error('No has seleccionado ningún EPC', { timeout: 3000 });
      return;
    }
    if (this.validaAtencion()) {
      // if (this.atencion.fecha == '') {
      //   this.$snotify.error('Debe ingresar una fecha', { timeout: 3000 });
      //   return;
      // }
      if (this.atencion.tipoCambio == '') {
        this.$snotify.error('Debe ingresar un tipo de cambio', {
          timeout: 3000,
        });
        return;
      }
    }
    this.dialogPopUp = true;
    this.contextPopUp = {
      title: 'Generar Atención',
      msg: `¿Está seguro que desea generar una atención para la nota de venta ${this.localData['Nombre NDV']}?`,
      attention: null,
      btnConfirmation: 'Confirmar',
    };
  }
  handleShowPopUp(confirmation: boolean): void {
    if (!confirmation) {
      this.mostrarHijo = false;
      return this.clearDataPopUp();
    }
    this.confirmations++;
    this.validateSatateValue({
      confirmations: this.confirmations,
      epc_seleccionados: this.contextPopUp.attention,
    });
  }
  clearDataPopUp(): void {
    this.dialogPopUp = false;
    this.confirmations = 0;
    this.contextPopUp = {};
  }
  async handleGenerate(epc_seleccionados: any): Promise<void> {
    //console.log('this.gridApi.getSelectedRows ', this.gridApi.getSelectedRows())
    let selectedRowns = this.gridApi.getSelectedRows();
    selectedRowns = selectedRowns.map(item => ({
      ndvnumero: item.ndvnumero,
      'CRM Serie': item['CRM Serie'],
      EPC: item['EPC'],
      producto: item['CRM Producto'],
    }));
    const user: { rutClienteDefecto: string } = JSON.parse(
      localStorage.getItem('user') || '{}'
    );
    const ndvcliente_rut = user.rutClienteDefecto;
    this.loadingService.showLoading();
    let data: any = {
      endpoint:
        this.tipo_emision == 'facturacion'
          ? 'facturacion_manual'
          : 'crear_documento_comercial',
      body: {
        ndvcliente_rut,
        ndvnumero: this.localData.ndvnumero,
        'Nombre NDV': this.localData['Nombre NDV'],
        atencion: this.atencion,
        epc_seleccionados: selectedRowns,
      },
    };

    if (this.tipo_emision == 'atencion') {
      data.serviceClient = 'integracion_inet';
    }

    await fetchNDV(data)
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA === 'SIN DATA') {
          // console.log('error ', MENSAJE_RESPUESTA);
          // console.log('this.isValidJson(this.lista_errores) ', this.isObject(MENSAJE_RESPUESTA))
          if (this.isObject(MENSAJE_RESPUESTA)) {
            this.lista_errores = MENSAJE_RESPUESTA;
            this.$snotify.error(this.lista_errores['respuesta_interna'], {
              timeout: 3000,
            });
            this.modal_errores = true;
            return;
          }
          this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return;
        }
        this.$snotify.success(MENSAJE_RESPUESTA, { timeout: 3000 });
        this.handleClosed();
      })
      .catch((error: Error) => {
        this.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        return;
      })
      .finally(() => {
        this.mostrarHijo = false;
        this.loadingService.hideLoading();
      });
  }
  isValidJson(obj: any) {
    try {
      if (this.isObject(obj)) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  }
  isObject(value: any) {
    return value && typeof value === 'object' && value.constructor === Object;
  }
  validateSatateValue({
    confirmations,
    epc_seleccionados,
  }: {
    confirmations: number;
    epc_seleccionados: any;
  }): void {
    if (confirmations === 1) {
      this.dialogPopUp = false;
      this.mostrarHijo = true;
      this.contextPopUp.title = 'Aviso Importante';
      this.contextPopUp.msg =
        'Puede validar si hay atenciones vigentes para esta nota de venta en la opción Ver Detalle y debe realizar la anulación manual en INET y en la opción de Atenciones';
      this.contextPopUp.btnConfirmation = 'Continuar';
      setTimeout(() => (this.dialogPopUp = true), 800);
    }
    if (confirmations === 2) {
      this.handleGenerate(epc_seleccionados);
      this.clearDataPopUp();
    }
  }
  async getData(): Promise<any> {
    const self = this;
    self.loadingService.showLoading();
    const es_atencion =
      (this.validaAtencion() && this.atencion.tipoDocumento == '915') ||
      this.validaFacturacionEspecial()
        ? 'si'
        : 'no';
    return await fetchNDV({
      endpoint: 'get_reservations',
      body: {
        ndvnumero: this.localData.ndvnumero,
        filtrar_facturados: false,
        es_atencion: es_atencion,
      },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA === 'SIN DATA') {
          self.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
        this.gridApi.setRowData(LISTA);
        return LISTA;
      })
      .catch((error: Error) => {
        //console.error(error.message);
        self.$snotify.error(
          'Ha ocurrido un error inesperado, por favor intente más tarde',
          { timeout: 3000 }
        );
        throw error;
      })
      .finally(() => {
        self.loadingService.hideLoading();
      });
  }
  async getFechaMax() {
    return await fetchNDV({
      serviceClient: 'servicios_uf',
      endpoint: 'get_fecha_maxima',
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA === 'SIN DATA') {
          return;
        }
        this.fecha_maxima = LISTA[0].fecha_max;
        return;
      })
      .catch((error: Error) => {
        throw error;
      });
  }
  async getTipoCambio() {
    this.loadingService.showLoading();
    return await fetchNDV({
      serviceClient: 'servicios_uf',
      endpoint: 'get_valor_especifico',
      body: {
        fecha: this.atencion.fecha,
      },
    })
      .then(response => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = response.data;
        if (CODIGO_RESPUESTA != '1' || MENSAJE_RESPUESTA === 'SIN DATA') {
          return;
        }
        this.atencion.tipoCambio = LISTA[0].valor_uf;
        return;
      })
      .catch((error: Error) => {
        throw error;
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }
  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }
  handleCancel() {
    this.handleClosed();
  }
  validaFacturacionEspecial(): boolean {
    return this.tipo_emision === 'facturacion';
  }
  validaAtencion(): boolean {
    return this.tipo_emision === 'atencion';
  }
  handleModalInformativo(val: any) {
    this.modal_errores = val;
    this.lista_errores = null;
  }
  @Watch('atencion.tipoDocumento')
  getDataFiltros() {
    this.getTipoCambio();
    this.getData();
  }
  @Watch('atencion.fecha')
  wFecha() {
    this.getTipoCambio();
  }

  private colsGrid(): ColDef[] {
    const coldef: ColDef[] = [
      {
        headerName: 'EPC',
        field: 'EPC',
        headerCheckboxSelection: true,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'CRM Producto',
        field: 'CRM Producto',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'CRM Plataforma',
        field: 'CRM Plataforma',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'CRM Serie',
        field: 'CRM Serie',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'Nombre EPC',
        field: 'NombreEPC',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
      {
        headerName: 'Equipo',
        field: 'Equipo',
        cellStyle: { textAlign: 'left' },
        resizable: true,
      },
    ];
    return coldef;
  }
}
